import { Link } from "react-router-dom";

// Banner verdi trasparenti: opzioni di una pagina sempre visibili in alto.
// items: [{ label, icon, to?, onClick?, anchor?, active?, hint? }]
export const OptionBanners = ({ items, testid = "option-banners", cols = "grid-cols-2 sm:grid-cols-3 lg:grid-cols-4" }) => (
  <div className={`grid ${cols} gap-3`} data-testid={testid}>
    {items.filter(Boolean).map((it) => {
      const cls = `mo-banner flex items-center gap-3 rounded-xl border px-4 py-3 text-sm font-semibold text-left transition-colors ${it.active ? "mo-banner-active" : ""}`;
      const inner = (
        <>
          <span className="h-9 w-9 rounded-lg mo-banner-icon flex items-center justify-center shrink-0"><it.icon className="h-4 w-4" /></span>
          <span className="min-w-0"><span className="block leading-tight truncate">{it.label}</span>{it.hint && <span className="block text-xs font-normal opacity-70 truncate">{it.hint}</span>}</span>
        </>
      );
      const tid = `banner-${it.label.toLowerCase().replace(/\s/g, "-").replace(/[^a-z0-9-]/g, "")}`;
      if (it.to) return <Link key={it.label} to={it.to} className={cls} data-testid={tid}>{inner}</Link>;
      const go = () => { it.onClick?.(); if (it.anchor) document.getElementById(it.anchor)?.scrollIntoView({ behavior: "smooth", block: "start" }); };
      return <button key={it.label} type="button" onClick={go} className={cls} data-testid={tid}>{inner}</button>;
    })}
  </div>
);
